import React, { Component } from 'react'
import NewAppointmentModal from './NewAppointmentModal'
import { notify } from '../../files/toasts'
import { t } from 'i18n'

class NewAppointmentButton extends Component {
  constructor(props) {
    super(props)
    this.state = {
      newAppointmentModalActive: false
    }
  }

  renderNewAppointmentModal() {
    if (this.state.newAppointmentModalActive) {
      return (
        <NewAppointmentModal
          projectId={this.props.projectId}
          notaryId={this.props.notaryId}
          closeModal={this.toggleModalActive}
          placesOfPractice={this.props.placesOfPractice}
          onSave={this.handleAppointmentSave}
          isNotary={this.props.isNotary}
        />
      )
    }
  }

  handleAppointmentSave = () => {
    this.toggleModalActive()
    notify({ text: t('components.appointments_calendar.appointment_saved') })
  }

  toggleModalActive = () => {
    this.setState({ newAppointmentModalActive: !this.state.newAppointmentModalActive })
  }

  render() {
    return(
      <div>
        <a href='#' onClick={this.toggleModalActive} className={this.props.className}>
          <i className='fa fa-plus me-2' />
          {t('components.project.next_appointment')}
        </a>
        {this.renderNewAppointmentModal()}
      </div>
    )
  }
}

export default NewAppointmentButton
